module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scroll-nav"
  }, [_c('div', {
    staticClass: "row-flex centered-between"
  }, [_c('div', {
    staticClass: "row-flex all-centered scroll-nav__row"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.query),
      expression: "query",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "scroll-nav__input",
    attrs: {
      "type": "text",
      "placeholder": "Ir para…"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value.trim()
      }, _vm.onInput],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onEnterFromInput($event)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.isSuggestOpen && _vm.suggestions.length) ? _c('div', {
    staticClass: "scroll-nav__suggestions"
  }, [_c('ul', {
    staticClass: "scroll-nav__suggestions-list"
  }, _vm._l((_vm.suggestions), function(item, i) {
    return _c('li', {
      key: item.id,
      staticClass: "scroll-nav__suggestion",
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          return _vm.onSuggestionClick(item)
        }
      }
    }, [_c('span', {
      staticClass: "scroll-nav__suggestion-label"
    }, [_vm._v(_vm._s(item.label))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "scroll-nav__btn",
    attrs: {
      "disabled": !_vm.hasPrev,
      "title": _vm.hasPrev ? '<h5> ir para: #' + _vm.ids[_vm.currentIndex - 1].id + '</h5>' : ''
    },
    on: {
      "click": _vm.prev
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-up",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "scroll-nav__btn",
    attrs: {
      "disabled": !_vm.hasNext,
      "title": _vm.hasNext ? '<h5> ir para: #' + _vm.ids[_vm.currentIndex + 1].id + '</h5>' : ''
    },
    on: {
      "click": _vm.next
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        placement: 'right',
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  placement : 'right', animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticClass: "scroll-nav__btn-home",
    attrs: {
      "title": "<h5> Voltar ao início </h5>"
    },
    on: {
      "click": _vm.home
    }
  }, [_c('i', {
    staticClass: "fa fa-home",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9dccad92!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/proposta/NavegadorProposta.vue
// module id = 2050
// module chunks = 1